import { createContext } from 'react'

import type { DownloadRequest, DownloadState } from './model'

export const DownloadContext = createContext<{
    state: DownloadState | null
    start: (request: DownloadRequest) => boolean
    cancel: () => void
    retry: () => void
    dismiss: () => void
} | null>(null)
